import React from "react";

// reactstrap components
import { Container } from "reactstrap";

// core components

function AboutUsHeader() {
  return (
    <>
      <div
        className="page-header page-header-small"
        style={{
          backgroundImage:
            "url(" + require("assets/img/event.jpg") + ")",
        }}
      >
        <div className="filter" />
        <div className="content-center">
          <Container>
            <h1>
             Smart Event & Production 
             <br />
            </h1>
            <h3>About Us</h3>
          </Container>
        </div>
      </div>
    </>
  );
}

export default AboutUsHeader;
